import React from "react";
import carnaval from "../Images/carnaval.webp";
import ButtonArrow from "../components/ButtonArrow";
import CarouselComponent from "../components/CarouselComponent";
import { useHeader } from "../Contexts/HeaderContext";
import { Helmet } from "react-helmet";

const Carnaval = () => {
  const { marginTop } = useHeader();
  return (
    <main className="z-2 postiion-relative">
      <Helmet>
        <title>Carnaval de Bella Unión – Tradición, Música y Fiesta</title>
        <meta
          name="description"
          content="El Carnaval de Bella Unión: tradición, música y color en una fiesta cultural que celebra la identidad y alegría de nuestra comunidad."
        />
        <meta
          name="keywords"
          content="carnaval Bella Unión, fiesta cultural Uruguay, música Bella Unión, tradición carnaval, eventos Bella Unión"
        />
        <link rel="canonical" href="https://bellaunion.uy/carnaval" />
        <meta property="og:title" content="Carnaval de Bella Unión – Tradición, Música y Fiesta" />
        <meta
          property="og:description"
          content="El Carnaval de Bella Unión: tradición, música y color en una fiesta cultural que celebra la identidad y alegría de nuestra comunidad."
        />
        <meta property="og:url" content="https://bellaunion.uy/carnaval" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={carnaval} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Carnaval de Bella Unión – Tradición, Música y Fiesta" />
        <meta
          name="twitter:description"
          content="El Carnaval de Bella Unión: tradición, música y color en una fiesta cultural que celebra la identidad y alegría de nuestra comunidad."
        />
        <meta name="twitter:image" content={carnaval} />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <CarouselComponent />
      <div
        className="position-absolute top-0 w-100 d-flex flex-column z-3 filter-dark"
        style={{ height: "100vh" }}
      >
        <h1 className="text-center text-light mt-auto">Carnaval</h1>
        <div className="mb-auto text-center mt-5">
          <ButtonArrow />
        </div>
      </div>
      <div className="bg-light" id="main-container" style={{ marginTop: "100vh" }}>
        <div className="container">
          <div className="row g-0 justify-content-center py-5">
            <h2 className="text-center mb-5">Nuestro Carnaval</h2>
            <div className="col-lg-5 order-lg-1 order-2 d-flex align-items-center">
              <div className="p-5 bg-white rounded shadow fs-5 text-center">
                <p>
                  En el mes de febrero, tiene lugar el Carnaval de Bella Unión. Conocido como "el Carnaval más
                  dulce del país", haciendo alusión al dominio de la producción de caña de azúcar en la
                  región.
                </p>
                <p>
                  La singularidad de este evento se ve determinada por su ubicación en la triple frontera
                  entre Barrado Quaraí (Brasil), Monte Caseros (Argentina) y Bella Unión (Uruguay). Esta
                  particular situación geográfica se refleja de manera notable en diversas facetas del
                  carnaval, desde las fantasías adoptadas por los participantes originarios de los países
                  limítrofes hasta las sambas enredos, las cuales son interpretadas en español.
                </p>
                <p>
                  Esta fusión de influencias crea una experiencia festiva única, donde la riqueza cultural de
                  Brasil, Argentina y Uruguay se entrelaza en una celebración vibrante y llena de color. La
                  conexión entre la producción local de caña de azúcar y el carácter internacional del evento
                  añade un elemento distintivo al Carnaval de Bella Unión, resaltando la intersección de la
                  economía regional y la diversidad cultural.
                </p>
              </div>
            </div>
            <div className="col-lg-5 order-lg-2 order-1 d-flex align-items-center">
              <img src={carnaval} alt="Desfile de carnaval" className="w-100 rounded shadow" />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Carnaval;
